import CONST from "../../config/CONST";

export const simulateDelay = async () => {
    if(CONST.ENV === "development") { // force delay in development mode (in order to test loading status
        await new Promise(r => setTimeout(r, CONST.FORCE_ASYNC_DELAY));
    }
}

export default simulateDelay;
